import { Component, OnInit, Input, SimpleChanges, ViewChild, ElementRef, EventEmitter, Output } from '@angular/core';
import { HelpersService, TiposCalculos } from '../../../../../services/tools/helpers.service';
import { PagosService } from '../../../../../services/pagos.service';
import { ArchivosPagosService } from "../../../../../services/archivos-pagos.service";
import { CreditosService } from "../../../../../services/creditos.service";
import { switchMap } from 'rxjs/operators';

@Component({
  selector: 'agregar-pago',
  templateUrl: './agregar-pago.component.html'
})
export class AgregarPagoComponent implements OnInit {
  @Input() public idCreditos: number = null;
  @Input() public isValidToAddPago: number = null;
  @ViewChild('closeBtn') closeBtn: ElementRef;
  @ViewChild('editarPagoBtn') editarPagoBtn: ElementRef;
  @Output() public onPagoCreated: EventEmitter<string> = new EventEmitter();

  // Modelo y estado
  public errors: any = {};
  public pago: any = { forma: '', tipo_abono: '', porcentaje_descuento: null };
  public tipoPagoSelected: any = '';
  public opcionesPagos: any[] = [];
  public archivo: any = null;
  public tiposAbonos: any[] = [];

  // Helpers y control carga
  public loadingTiposPagos: boolean = false;

  // Monto personalizado para tipo "Otro"
  public montoPersonalizado: number = 0;
  public saldoRestante: number = 0;
  public interes_generado: number = 0;
  public saldoParaLiquidar: number = 0;
  public diasRetraso: number = 0;
  public porcentajeCondonado: number = 0;

  // Estado para subpagos expandibles
  expandedPagos: { [idPago: number]: boolean } = {};
  loadingSubPagos: { [idPago: number]: boolean } = {};
  subpagosPorPago: { [idPago: number]: any[] } = {};

  constructor(
    private helperService: HelpersService,
    private pagosService: PagosService,
    private archivosService: ArchivosPagosService,
    private creditosService: CreditosService
  ) { }

  ngOnInit() { }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.idCreditos && this.idCreditos) {
      this.getCredito(this.idCreditos);
    }
  }

  private getCredito(idCreditos: number) {
    this.creditosService.get(idCreditos).subscribe(
      (response) => {
        const credito = response.json().content;
        this.setupTiposAbono(credito.prestamo.calculo);
      },
      (error) => {
        this.helperService.httpGlobalError(error);
        if (error.status == 400) {
          this.helperService.setBackendErrors(error.json().content, this.errors);
          this.helperService.notification(
            'ERROR',
            'No se completó la acción. Por favor, intenta más tarde.',
            'error'
          );
        }
      }
    );
  }

  public getOpcionesPago() {
    let idPago = this.pago.id ? this.pago.id : null;
    let porcentaje_descuento = this.pago.porcentaje_descuento ? this.pago.porcentaje_descuento : null;
    this.loadingTiposPagos = true;

    this.pagosService.getOpcionesPago(this.idCreditos, idPago, porcentaje_descuento).subscribe(
      (response) => {
        const opcionesPago = response.json().content;
        console.log('Opciones de pago recibidas:', opcionesPago);
        this.opcionesPagos = opcionesPago;
        this.loadingTiposPagos = false;
      },
      (error) => {
        this.helperService.httpGlobalError(error);
        this.loadingTiposPagos = false;
        if (error.status == 400) {
          this.helperService.setBackendErrors(error.json().content, this.errors);
          this.helperService.notification(
            'ERROR',
            'No se completó la acción. Por favor, intenta más tarde.',
            'error'
          );
        }
      }
    );
  }

  private getArchivoPago(idPago: number) {
    this.archivosService.get(idPago).subscribe(
      (response) => {
        const archivos = response.json().content;
        if (archivos.length) {
          this.archivo = archivos[0];
        }
      },
      (error) => {
        this.helperService.httpGlobalError(error);
        if (error.status == 400) {
          this.helperService.setBackendErrors(error.json().content, this.errors);
          this.helperService.notification(
            'ERROR',
            'No se completó la acción. Por favor, intenta más tarde.',
            'error'
          );
        }
      }
    );
  }

  public save() {
    this.errors = {};
    let pago = this.pago;
    console.log('Contenido de pago:', pago);

    pago.monto_pago = null;
    pago.tipo = null;

    this.opcionesPagos.forEach((tipoPago) => {
      if (tipoPago.opcion === this.tipoPagoSelected.opcion) {
        pago.tipo = tipoPago.opcion;
        if (tipoPago.opcion === 5) {
          pago.monto_pago = tipoPago.monto2;
          pago.monto = this.montoPersonalizado;
          pago.porcentaje_descuento = this.porcentajeCondonado;
        } else {
          pago.monto_pago = tipoPago.monto;
        }
      }
    });

    this.pago.porcentaje_descuento = pago.porcentaje_descuento ? pago.porcentaje_descuento : null;

    this.errors = this.pagosService.validate(pago);
    if (Object.entries(this.errors).length > 0) {
      return false;
    }

    if (!this.pago.abono || this.pago.abono.toString().length == 0) {
      this.pago.tipo_abono = null;
      this.pago.abono = null;
    }

    if (pago.id) {
      this.update(pago);
    } else {
      pago.idCreditos = this.idCreditos;
      this.create(pago);
    }
  }

  private create(pago: any): void {
    console.info('🟡 Iniciando proceso de creación de pago', pago);

    this.pagosService.save(pago).subscribe(
      (response) => {
        const result = response.json().content;
        console.info('✅ Respuesta del backend:', result);
        this.helperService.notification('Pago creado', 'Se ha registrado exitosamente el pago', 'success');
        this.setupAfterSave();
        this.getOpcionesPago();
      },
      (error) => {
        console.error('🔴 Error al crear el pago:', error);
        this.helperService.httpGlobalError(error);
        if (error.status === 400) {
          const backendErrors = error.json().content;
          console.warn('⚠️ Errores de validación del backend:', backendErrors);
          this.showBackendError(backendErrors);
        }
      }
    );
  }

  private update(pago: any) {
    this.pagosService.update(pago).subscribe(
      (response) => {
        const result = response.json().content;
        this.helperService.notification('Pago actualizado', 'Se ha actualizado exitosamente el pago', 'success');
        this.setupAfterSave();
        this.getOpcionesPago();
      },
      (error) => {
        this.helperService.httpGlobalError(error);
        if (error.status == 400) {
          this.showBackendError(error.json().content);
        }
      }
    );
  }

  private showBackendError(jsonErrors: any) {
    if (jsonErrors.abono) {
      this.errors['abono'] = jsonErrors.abono;
      this.errors['tipo'] = jsonErrors.abono;
    }
  }

  public showModalPago(idPago: number) {
    this.resetPagoModel();
    this.editarPagoBtn.nativeElement.click();

    if (idPago) {
      this.getOpcionesPagoAndPagoDetails(idPago);
      this.getArchivoPago(idPago);
    }
  }

  private getOpcionesPagoAndPagoDetails(idPago: number) {
    const ctrl = this;

    this.pagosService
      .getPago(idPago)
      .pipe(
        switchMap((pagoResponse) => {
          const pago = pagoResponse.json().content;
          ctrl.pago = pago;
          return this.pagosService.getOpcionesPago(ctrl.idCreditos, idPago, ctrl.pago.porcentaje_descuento);
        })
      )
      .subscribe(
        (opciones) => {
          ctrl.opcionesPagos = opciones.json().content;

          ctrl.opcionesPagos.forEach(function (tipoPago) {
            if (tipoPago.opcion === ctrl.pago.tipo) {
              ctrl.tipoPagoSelected = tipoPago;
            }
          });
        },
        (error) => {
          this.helperService.httpGlobalError(error);
          if (error.status == 400) {
            this.helperService.setBackendErrors(error.json().content, this.errors);
            this.helperService.notification('ERROR', 'No se completó la acción. Por favor, intenta más tarde.', 'error');
          }
        }
      );
  }

  private setupAfterSave() {
    this.onPagoCreated.emit();
    this.closeBtn.nativeElement.click();
    this.resetPagoModel();
  }

  public setupForNewPago() {
    this.resetPagoModel();

    this.loadingTiposPagos = true;
    this.pagosService
      .getOpcionesPago(this.idCreditos, null, null)
      .subscribe((response) => {
        this.opcionesPagos = response.json().content;
        this.loadingTiposPagos = false;

        // ✅ selecciona opción por defecto
        if (this.opcionesPagos.length) {
          this.tipoPagoSelected = this.opcionesPagos[0];
          this.onTipoPagoChange();
        }
      });
  }


  private resetPagoModel() {
    this.tipoPagoSelected = '';
    this.pago = { forma: '', tipo_abono: '' };
    this.archivo = null;
    this.errors = [];
    this.montoPersonalizado = 0;
    this.saldoRestante = 0;
    this.interes_generado = 0;
    this.saldoParaLiquidar = 0;
    this.porcentajeCondonado = 0;
  }

  public uploadFile(event: any) {
    let fileInfo = {
      idPagos: this.pago.id ? this.pago.id : null
    };

    let observableResponse = this.archivosService.save(event, fileInfo);
    if (!observableResponse) {
      return;
    }

    observableResponse.subscribe(
      (response) => {
        let archivo = response.json().content;
        this.pago.idArchivo = archivo.id;
        this.archivo = archivo;
        this.helperService.notification('Archivo agregado', 'Se ha agregado exitosamente el archivo', 'success');
      },
      (error) => {
        this.helperService.httpGlobalError(error);
        if (error.status == 400) {
          this.helperService.setBackendErrors(error.json().content, this.errors);
          this.helperService.notification('ERROR', 'No se completó la acción. Por favor, intenta más tarde.', 'error');
        }
      }
    );
  }

  public downloadFile() {
    this.archivosService.getFile(this.archivo.id).subscribe(
      (response) => {
        const fileUrl = window.URL.createObjectURL(response.blob());
        window.open(fileUrl);
      },
      (error) => {
        this.helperService.httpGlobalError(error);
        if (error.status == 400) {
          this.helperService.setBackendErrors(error.json().content, this.errors);
          this.helperService.notification('ERROR', 'No se completó la acción. Por favor, intenta más tarde.', 'error');
        }
      }
    );
  }

  public deleteFile() {
    this.archivosService.delete(this.archivo.id).subscribe(
      (response) => {
        this.archivo = null;
        this.helperService.notification('Archivo eliminado', 'Se ha eliminado exitosamente el archivo ', 'success');
      },
      (error) => {
        this.helperService.httpGlobalError(error);
        if (error.status == 400) {
          this.helperService.setBackendErrors(error.json().content, this.errors);
          this.helperService.notification('ERROR', 'No se completó la acción. Por favor, intenta más tarde.', 'error');
        }
      }
    );
  }

  private setupTiposAbono(calculo: number) {
    let tiposAbonos = [];
    switch (calculo) {
      case TiposCalculos.Simple:
        tiposAbonos.push({
          value: 2,
          label: 'Reducir el monto de los siguientes pagos'
        });
        break;
      case TiposCalculos.Insoluto:
      case TiposCalculos.Soluto:
      case TiposCalculos.MesesSinIntereses:
        tiposAbonos.push({
          value: 1,
          label: 'Reducir número de plazos'
        });
        tiposAbonos.push({
          value: 2,
          label: 'Reducir el monto de los siguientes pagos'
        });
        break;
    }
    this.tiposAbonos = tiposAbonos;
  }

  public print() {
    window.print();
  }

public recalcularSaldo(valor: any): void {
    // 1. Limpiamos el valor. Si viene de la máscara con dropSpecialCharacters, 
    // ya debería ser un número o un string limpio.
    const limpio = Number(valor.toString().replace(/,/g, '').trim()) || 0;

    // IMPORTANTE: No sobreescribas 'this.montoPersonalizado' aquí 
    // si el valor ya viene del ngModel, porque causas un conflicto con la máscara.
    // this.montoPersonalizado = limpio; <-- ELIMINA O COMENTA ESTA LÍNEA

    this.pago.interes = this.tipoPagoSelected.interes || 0;

    const montoBase = (this.tipoPagoSelected && this.tipoPagoSelected.monto2) || 0;
    
    // Usamos la variable 'limpio' para los cálculos
    this.saldoRestante = montoBase - limpio;
    this.interes_generado = this.tipoPagoSelected.interes_generado;
    this.saldoParaLiquidar = this.saldoRestante + this.interes_generado;

    if (this.saldoRestante < 0) {
      this.errors.montoPersonalizado = 'El monto no puede exceder el total.';
    } else {
      delete this.errors.montoPersonalizado;
    }

    if (this.pago.condonar_saldo && montoBase > 0 && this.saldoRestante >= 0) {
      this.porcentajeCondonado = (this.saldoRestante / montoBase) * 100;
    } else {
      this.porcentajeCondonado = 0;
    }
}


  // 🔹 Cuando el usuario cambia la fecha manualmente
  onFechaPagoChange(fechaSeleccionada: string): void {
    this.pago.fecha = fechaSeleccionada;


    // Solo calcular penalización si es "Pago del periodo"
    if (this.tipoPagoSelected && this.tipoPagoSelected.opcion === 1) { // ajustar según tu lógica
      this.calcularInteresMora(fechaSeleccionada);
    } else {
      console.log('ℹ️ Tipo de pago no es "Pago del periodo", no se calcula penalización');
      this.calcularInteresMora(fechaSeleccionada);
    }
  }




  calcularInteresMora(fechaSeleccionada?: string) {

    console.log('📅 Fecha seleccionada por el usuario:', this.tipoPagoSelected.fecha_solicitud);

    // -------------------------------
    // 1️⃣ Determinar monto restante
    // -------------------------------
    let montoRestante = 0;

    if (this.saldoRestante != null) {
      montoRestante = Number(this.saldoRestante);
      console.log('💰 Monto restante tomado de saldoRestante:', montoRestante);
    } else if (this.tipoPagoSelected.monto2 != null) {
      montoRestante = Number(this.tipoPagoSelected.monto2);
      console.log('💰 Monto restante tomado de tipoPagoSelected.monto2:', montoRestante);
    } else {
      console.warn('⚠️ Monto restante no disponible, se usará 0');
    }

    // -------------------------------
    // 2️⃣ Determinar fecha base
    // -------------------------------
    const fechaBaseStr =
      this.tipoPagoSelected.ultimo_subpago ||
      this.tipoPagoSelected.fecha_solicitud ||
      null;
    console.log('📅 Fecha base para mora:', fechaBaseStr);

    const fechaBase = fechaBaseStr ? new Date(fechaBaseStr) : null;

    if (!fechaBase || isNaN(fechaBase.getTime())) {
      console.warn('⚠️ Fecha base inválida');
      this.interes_generado = 0;
      this.diasRetraso = 0;
      this.pago.penalizacion = 0;
      this.actualizarSaldoParaLiquidar();
      return;
    }

    // -------------------------------
    // 3️⃣ Fecha seleccionada
    // -------------------------------
    const fechaPago = fechaSeleccionada ? new Date(fechaSeleccionada) : new Date();

    if (isNaN(fechaPago.getTime())) {
      console.warn('⚠️ Fecha seleccionada inválida, se usa fecha actual');
    }

    console.log('📅 Fecha de pago seleccionada:', fechaPago);

    // -------------------------------
    // 4️⃣ Días de retraso
    // -------------------------------
    const diffMs = fechaPago.getTime() - fechaBase.getTime();
    const diasRetraso = Math.max(0, Math.floor(diffMs / (1000 * 60 * 60 * 24)));
    this.diasRetraso = diasRetraso;

    console.log(`📆 Días de retraso calculados: ${diasRetraso}`);

    // -------------------------------
    // 5️⃣ Penalización escalonada
    // -------------------------------
    let penalizacion = 0;
    let mensaje = '';
    const cantidadPagar = montoRestante || 0;

    if (diasRetraso > 0 && diasRetraso <= 7) {
      penalizacion = cantidadPagar * 0.05;
      mensaje = `Penalización del 5% aplicada (${diasRetraso} días de retraso)`;
      console.log('⚖️ Penalización 5% aplicada');
    } else if (diasRetraso > 7) {
      penalizacion = cantidadPagar * 0.12;
      mensaje = `Penalización del 12% aplicada (${diasRetraso} días de retraso)`;
      console.log('⚖️ Penalización 12% aplicada');
    } else {
      penalizacion = 0;
      mensaje = 'Pago dentro de fecha, sin penalización';
      console.log('✅ Pago dentro de fecha');
    }

    this.pago.penalizacion = Number(penalizacion.toFixed(2));

    // -------------------------------
    // 6️⃣ Interés de mora diario (sin romper tu penalización)
    // -------------------------------
    const tasaDiaria = (Number(this.tipoPagoSelected.tasa_convenio) / 100) / 30;

    const interesMora = montoRestante * tasaDiaria * this.diasRetraso;

    this.interes_generado = Number(interesMora.toFixed(2));
    this.pago.interes_mora = this.interes_generado;

    console.log(`💸 Penalización total: ${this.pago.penalizacion}`);
    console.log(`💰 Interés mora diario: ${this.interes_generado}`);

    // -------------------------------
    // 7️⃣ Actualizar saldo final
    // -------------------------------
    this.actualizarSaldoParaLiquidar();
  }





  private actualizarSaldoParaLiquidar(): void {
    let restante = 0;
    if (this.saldoRestante !== null && this.saldoRestante !== undefined) {
      restante = Number(this.saldoRestante);
    } else if (this.tipoPagoSelected && this.tipoPagoSelected.monto2 !== undefined) {
      restante = Number(this.tipoPagoSelected.monto2);
    } else {
      restante = 0;
    }

    const penalizacion = Number(this.pago.penalizacion) || 0;
    const interes = Number(this.interes_generado) || 0;

    this.saldoParaLiquidar = restante + interes + penalizacion;
    //this.montoPersonalizado = restante + interes + penalizacion;


    console.log(`💵 Saldo para liquidar: ${this.saldoParaLiquidar} (Restante: ${restante}, Interés: ${interes}, Penalización: ${penalizacion})`);
  }

  get totalAPagar(): number {
    const abono = Number(this.pago.abono != null ? this.pago.abono : 0);
    const interes = Number(this.interes_generado != null ? this.interes_generado : 0);
    const penalizacion = Number(this.pago.penalizacion != null ? this.pago.penalizacion : 0);

    return abono + interes + penalizacion;
  }

  // 🔹 Cuando se cambia el tipo de pago
  public onTipoPagoChange() {
    if (this.tipoPagoSelected) {
      this.pago.tipo = this.tipoPagoSelected.opcion;
      console.log('📌 Tipo de pago: "Pago del periodo", calculando penalización...');
      // Si es "Pago del periodo", calcular penalización automáticamente
      if (this.tipoPagoSelected.opcion === 1) {
        const fechaPago = this.pago.fecha || new Date().toISOString().split('T')[0];
        this.pago.fecha = fechaPago;

        console.log('📌 Tipo de pago: "Pago del periodo", calculando penalización...');
        this.calcularInteresMora(fechaPago);
      }
    } else {
      this.pago.tipo = null;
    }
  }



}



// WEBPACK FOOTER //
// ./src/app/creditos/components/tabla-pagos/components/agregar-pago/agregar-pago.component.ts